import React, {Component, useEffect, useState} from "react";
import {BrowserRouter, Link, Route, Routes} from "react-router-dom";
import TeamDetailPage from "./TeamPlayersPage";
// import styles from '../styles/TeamPlayersPage.module.css'
import styles from '../styles/TeamGamesPage.module.css'
import { useParams } from 'react-router-dom'
import profileStyles from "../styles/PlayerProfile.module.css";
import SeasonDropdown from "../components/SeasonDropdown";


const formatDate = (dateString) => {
    // const options = { year: 'numeric', month: 'long', day: 'numeric' };
    // return new Date(dateString).toLocaleDateString(undefined, options);
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day); // Create a date object in local time
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
};


export function RenderGameList({ games, teamAbb }) {
    const sortedGames = games.slice().sort((a, b) => new Date(b.date) - new Date(a.date));

    const renderGameScore = (game) => {
        let suffix = "";
        if (game.final_period === "OT") {
            suffix = " (OT)";
        } else if (game.final_period === "SO") {
            suffix = " (SO)";
        }
        return (
            <div className={styles.gameScore}>
                <strong>{game.winner_score}</strong> {' — ' + game.loser_score + suffix}
                {/*<strong>{game.winner + ' ' + game.winner_score}</strong> {' — ' + game.loser_score + ' ' + game.loser + suffix}*/}
                {/*{game.winner + ' ' + game.winner_score + ' — ' + game.loser_score + ' ' + game.loser + suffix}*/}
            </div>
        );
    };

    return sortedGames.map(game => (
        <Link key={game.id} className={styles.gameRows} to={`/games/id/${game.id}`}>
            {/*<li className="list-group-item list-group-item-action d-flex justify-content-between"*/}
            {/*    key={game.id}*/}
            {/*>*/}
            <li className={styles.gameRow} key={game.id} data-winner={game.winner}>
                <div className={styles.gameDate}>
                    {formatDate(game.date)}
                </div>
                <span className={styles.teamLogoContainer}>
                   <img className={styles.teamLogo}
                        src={`https://assets.nhle.com/logos/nhl/svg/${game.winner}_light.svg`}
                        alt={`${game.winner} logo`}
                   />
                </span>
                {renderGameScore(game)}
                <span className={styles.teamLogoContainer}>
                   <img className={styles.teamLogo}
                        src={`https://assets.nhle.com/logos/nhl/svg/${game.loser}_light.svg`}
                        alt={`${game.loser} logo`}
                   />
                </span>
            </li>
        </Link>
    ));
}

function GamesTable({ games, team, handleSeasonChange, selectedSeason, teamColors }) {
    const params = useParams();
    const teamAbb = params.teamAbb

    let teamTitle;
    if (teamAbb === "NHL") {
        teamTitle = "All Games";
    } else {
        teamTitle = team.location + ' ' + team.name + ' Games';
    }

    return (
        <div className={styles.pageContainer}>
            <div className={styles.glassContainer}>
                <h1 className={styles.teamTableHeading} style={{ color: teamColors?.primary || '#1e293b' }}>
                    <img className={styles.teamLogo}
                         src={`https://assets.nhle.com/logos/nhl/svg/${teamAbb}_light.svg`}
                         alt={`${teamAbb} logo`}
                    />
                    {teamTitle}
                </h1>
                {/* Season Dropdown */}
                <SeasonDropdown selectedSeason={selectedSeason} onSeasonChange={handleSeasonChange}/>
                <div className={styles.gamesList}>
                    <RenderGameList games={games} teamAbb={teamAbb} />
                </div>
            </div>
        </div>
    );
}

function TeamGamesPage() {
    // const teamAbb = searchParams.get('teamAbb')
    const params = useParams();
    const teamAbb = params.teamAbb
    const [games, setGames] = useState([])
    const [team, setTeam] = useState([])
    const [loading, setLoading] = useState(true);
    const [selectedSeason, setSelectedSeason] = useState('20242025');  // Default season

    const handleSeasonChange = (season) => {
        setSelectedSeason(season);
    };


    useEffect(() => {
        getData()
            .catch(err => {
                console.log(err);
      });

    }, [])

    useEffect(() => {
      if (selectedSeason) {
        getData(selectedSeason).catch((err) => {
          console.log(err);
        });
      }
    }, [selectedSeason, teamAbb]); // Include teamAbb if it can change

    const getData = async () => {
        setLoading(true)
        let apiUrl =
        `/api/games/${teamAbb}/${selectedSeason}`
        const gameListResp = await fetch(apiUrl)
        const gameList = await gameListResp.json()
        setGames(gameList)

        if (teamAbb !== "NHL") {
            apiUrl = `/api/teams/${teamAbb}`
            const teamResp = await fetch(apiUrl)
            const teamData = await teamResp.json()
            // console.log(teamData)
            setTeam(teamData)
        }
        setLoading(false)
    }

    // Function to soften a hex color by mixing with white
    const softenColor = (hexColor, mixRatio = 0.7) => {
        // Remove # if present
        const hex = hexColor.replace('#', '');
        
        // Convert to RGB
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        
        // Mix with white (255, 255, 255)
        const softenedR = Math.round(r * (1 - mixRatio) + 255 * mixRatio);
        const softenedG = Math.round(g * (1 - mixRatio) + 255 * mixRatio);
        const softenedB = Math.round(b * (1 - mixRatio) + 255 * mixRatio);
        
        // Convert back to hex
        return `#${softenedR.toString(16).padStart(2, '0')}${softenedG.toString(16).padStart(2, '0')}${softenedB.toString(16).padStart(2, '0')}`;
    };

    // Compute dynamic background style with softened colors
    const backgroundStyle = team.primary_color && team.secondary_color
      ? {
          background: `linear-gradient(135deg, ${softenColor(team.primary_color)} 0%, ${softenColor(team.secondary_color)} 100%)`
        }
      : {};

    if(loading) return (
        <div className={styles.pageContainer} style={backgroundStyle}>
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    );

    const teamColors = {
        primary: team.primary_color,
        secondary: team.secondary_color
    };

    return (
        <div className={styles.pageContainer} style={backgroundStyle}>
            <GamesTable 
                games={games} 
                team={team} 
                handleSeasonChange={handleSeasonChange} 
                selectedSeason={selectedSeason}
                teamColors={teamColors}
            />
        </div>
    );
}

export default TeamGamesPage


